// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"388":"result","446":"questionnaire"}[chunkId] + "." + {"388":"37514de1","446":"11c38242"}[chunkId] + ".js";
};